import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { EventInput } from '@fullcalendar/common';
// utils
import axios from '../../utils/axios';
//
import { CalendarState } from '../../@types/calendar';
import {
  getEventList,
  addEvent,
  staffList,
  classList,
  studentList,
  get,
  deleteEvent,
  updateEvent,
  getClassTree
} from '../../api/Calendar';

// ----------------------------------------------------------------------

const initialState: CalendarState = {
  isLoading: false,
  error: false,
  events: [],
  isOpenModal: false,
  selectedEventId: null,
  selectedRange: null,
  staffList: [],
  classList: [],
  studentList: [],
  classTree: []
};

const slice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET EVENTS
    getEventsSuccess(state, action) {
      state.isLoading = false;
      state.events = action.payload;
    },

    // CREATE EVENT
    createEventSuccess(state) {
      state.isLoading = false;
    },

    // 更新日历事件
    updateEventSuccess(state) {
      state.isLoading = false;
    },

    // DELETE EVENT
    deleteEventSuccess(state) {
      state.isLoading = false;
    },
    // 获取事件详情
    getDetail(state) {
      state.isLoading = false;
    },

    // SELECT EVENT
    selectEvent(state, action) {
      const eventId = action.payload;
      state.isOpenModal = true;
      state.selectedEventId = eventId;
    },

    // SELECT RANGE
    selectRangeSuccess(state, action) {
      const { start, end } = action.payload;
      state.isOpenModal = true;
      state.selectedRange = { start, end };
    },

    // OPEN MODAL
    openModal(state) {
      state.isOpenModal = true;
    },

    // CLOSE MODAL
    closeModal(state) {
      state.isOpenModal = false;
      state.selectedEventId = null;
      state.selectedRange = null;
    },
    // 获取教职工列表成功
    getStaffListSuccess(state, action) {
      state.staffList = action.payload;
    },
    // 获取班级列表成功
    getClassTreeSuccess(state, action) {
      state.classTree = action.payload;
    },
    // 获取学生列表成功
    getStudentListSuccess(state, action) {
      state.studentList = action.payload;
      // console.log('22');
    }
  }
});

// Reducer
export default slice.reducer;

export const { openModal, closeModal, selectEvent } = slice.actions;

// ----------------------------------------------------------------------

export function getEvents(params: any) {
  return async (dispatch: any) => {
    try {
      const response = await getEventList(params);
      const EventRows = response.rows.map((item: any) => ({
        ...item,
        start: new Date(item.start.replace(/-/g, '/')),
        end: new Date(item.end.replace(/-/g, '/')),
        all_day: item.all_day === 'Y'
      }));
      dispatch(slice.actions.getEventsSuccess(EventRows));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createEvent(newEvent: Omit<EventInput, 'id'>) {
  return async (dispatch: any) => {
    try {
      const response = await addEvent(newEvent);
      console.log('response', response);
      dispatch(slice.actions.createEventSuccess());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateEventAction(params: any) {
  return async (dispatch: any) => {
    try {
      await updateEvent(params);
      dispatch(slice.actions.updateEventSuccess());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteEventAction(eventId: string, is_update_parent: string) {
  return async (dispatch: any) => {
    try {
      await deleteEvent(eventId, is_update_parent);
      dispatch(slice.actions.deleteEventSuccess());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

//  ----------------------------------------------------------------------

export function getEventDetail(id: string) {
  return async (dispatch: any) => {
    try {
      const res = await get(id);
      dispatch(slice.actions.getDetail);
      return res;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function selectRange(start: Date, end: Date) {
  return (dispatch: any) => {
    try {
      dispatch(slice.actions.selectRangeSuccess({ start, end }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
// 获取教职工列表
export function getStaffList(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await staffList(params);
      dispatch(slice.actions.getStaffListSuccess(res));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 获取班级列表
export function getClassList() {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await getClassTree();
      dispatch(slice.actions.getClassTreeSuccess(res.classTree));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 获取学生列表
export function getStudentList(params: any) {
  return async (dispatch: any) => {
    try {
      const res = await studentList(params);
      let ret = Object.values(
        res.reduce((acc: any, item: any) => {
          const { class_name, name, id, user_id } = item;
          if (!acc[class_name]) {
            acc[class_name] = {
              label: class_name,
              value: class_name,
              // key: class_name,
              children: []
            };
          }
          acc[class_name].children.push({
            label: name,
            value: user_id,
            // key: id,
            user_id
          });
          return acc;
        }, {})
      );
      dispatch(slice.actions.getStudentListSuccess(ret));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
